
import { macroCondition, getGlobalConfig } from '@embroider/macros';


import defineModule0 from "./-embroider-implicit-modules.js";

import * as amdModule0 from "./initializers/ember-data-identifiers.js"
import * as amdModule1 from "./lib/default-comprensorio.js"
import * as amdModule2 from "./resolver.js"
import * as amdModule3 from "./router.js"
import * as amdModule4 from "./serializers/application.js"
import * as amdModule5 from "./services/intl.js"
import * as amdModule6 from "./services/keyboard.js"
import * as amdModule7 from "./services/theme.js"
import * as amdModule8 from "./services/-ensure-registered.js"
import * as amdModule9 from "./services/notify.js"
import * as amdModule10 from "./initializers/app-version.js"
import * as amdModule11 from "./instance-initializers/sentry-performance.js"
import * as amdModule12 from "./instance-initializers/load-translations.js"
import * as amdModule13 from "./services/power-calendar.js"
import * as amdModule14 from "./test-support/helpers.js"
import * as amdModule15 from "./initializers/ember-data.js"
import * as amdModule16 from "./services/store.js"
import * as amdModule17 from "./transforms/date.js"
import * as amdModule18 from "./transforms/number.js"
import * as amdModule19 from "./transforms/string.js"
import * as amdModule20 from "./transforms/boolean.js"
import * as amdModule21 from "./data-adapter.js"
import * as amdModule22 from "./services/quill.js"
import * as amdModule23 from "./adapters/application.js"
import * as amdModule24 from "./adapters/contact.js"
import * as amdModule25 from "./adapters/organization.js"
import * as amdModule26 from "./models/address.js"
import * as amdModule27 from "./models/application.js"
import * as amdModule28 from "./models/assurance.js"
import * as amdModule29 from "./models/category.js"
import * as amdModule30 from "./models/contact-consensi.js"
import * as amdModule31 from "./models/contact-parent.js"
import * as amdModule32 from "./models/contact-state.js"
import * as amdModule33 from "./models/contact.js"
import * as amdModule34 from "./models/custom-field-definition.js"
import * as amdModule35 from "./models/custom-field.js"
import * as amdModule36 from "./models/custom-reminder.js"
import * as amdModule37 from "./models/event-state.js"
import * as amdModule38 from "./models/event.js"
import * as amdModule39 from "./models/expense.js"
import * as amdModule40 from "./models/expensearticle.js"
import * as amdModule41 from "./models/expensepayment.js"
import * as amdModule42 from "./models/expire-date.js"
import * as amdModule43 from "./models/file.js"
import * as amdModule44 from "./models/invoice-style.js"
import * as amdModule45 from "./models/invoice.js"
import * as amdModule46 from "./models/invoicegroup.js"
import * as amdModule47 from "./models/invoicemailsend.js"
import * as amdModule48 from "./models/invoiceproduct-tax.js"
import * as amdModule49 from "./models/invoiceproduct.js"
import * as amdModule50 from "./models/invoices-notifiche-sdi.js"
import * as amdModule51 from "./models/invoicetax.js"
import * as amdModule52 from "./models/log.js"
import * as amdModule53 from "./models/notification.js"
import * as amdModule54 from "./models/organization-custom-field.js"
import * as amdModule55 from "./models/organization.js"
import * as amdModule56 from "./models/payment-method.js"
import * as amdModule57 from "./models/payment.js"
import * as amdModule58 from "./models/plan.js"
import * as amdModule59 from "./models/product-category.js"
import * as amdModule60 from "./models/product-state.js"
import * as amdModule61 from "./models/product.js"
import * as amdModule62 from "./models/project-consensi.js"
import * as amdModule63 from "./models/project-state.js"
import * as amdModule64 from "./models/project.js"
import * as amdModule65 from "./models/reminder-setting.js"
import * as amdModule66 from "./models/reminder.js"
import * as amdModule67 from "./models/role.js"
import * as amdModule68 from "./models/sub-category.js"
import * as amdModule69 from "./models/subscription.js"
import * as amdModule70 from "./models/tag.js"
import * as amdModule71 from "./models/todo.js"
import * as amdModule72 from "./models/todolist.js"
import * as amdModule73 from "./models/user-calendar.js"
import * as amdModule74 from "./models/user-invoice-setting.js"
import * as amdModule75 from "./models/user-reminder.js"
import * as amdModule76 from "./models/user-sezionale.js"
import * as amdModule77 from "./models/user-tax.js"
import * as amdModule78 from "./models/workhour-state.js"
import * as amdModule79 from "./models/workhour.js"
import * as amdModule80 from "./services/session.js"
import * as amdModule81 from "./core-app.js"
import * as amdModule82 from "./formats.js"
import * as amdModule83 from "./initializers/fontawesome.js"
import * as amdModule84 from "./initializers/offline-banner.js"
import * as amdModule85 from "./instance-initializers/dev-host.js"
import * as amdModule86 from "./services/app-state.js"
import * as amdModule87 from "./services/application.js"
import * as amdModule88 from "./services/beebee-base.js"
import * as amdModule89 from "./services/document-sign.js"
import * as amdModule90 from "./services/idle-screensaver.js"
import * as amdModule91 from "./services/index-context.js"
import * as amdModule92 from "./services/log.js"
import * as amdModule93 from "./services/modal-stack.js"
import * as amdModule94 from "./services/modal.js"
import * as amdModule95 from "./services/new-record-factory.js"
import * as amdModule96 from "./services/notification-message.js"
import * as amdModule97 from "./services/ringtone.js"
import * as amdModule98 from "./services/role-checker.js"
import * as amdModule99 from "./services/socket-sync.js"
import * as amdModule100 from "./services/socket-tracker.js"
import * as amdModule101 from "./services/third-party-boot.js"
import * as amdModule102 from "./services/window-viewport.js"
import * as amdModule103 from "./components/assicurazione-aosta-valley.js"
import * as amdModule104 from "./components/assicurazione-snow-care.js"
import * as amdModule105 from "./components/base-product-price.js"
import * as amdModule106 from "./components/bb-field.js"
import * as amdModule107 from "./components/checkout-detail.js"
import * as amdModule108 from "./components/checkout-product.js"
import * as amdModule109 from "./components/cookie-banner.js"
import * as amdModule110 from "./components/custom-modules.js"
import * as amdModule111 from "./components/detail-calendar.js"
import * as amdModule112 from "./components/empty-category.js"
import * as amdModule113 from "./components/human-age.js"
import * as amdModule114 from "./components/inline-login.js"
import * as amdModule115 from "./components/level-selector.js"
import * as amdModule116 from "./components/list-cart-product.js"
import * as amdModule117 from "./components/list-filters.js"
import * as amdModule118 from "./components/list-levels.js"
import * as amdModule119 from "./components/not-available-label.js"
import * as amdModule120 from "./components/private-calendar.js"
import * as amdModule121 from "./components/product-list.js"
import * as amdModule122 from "./components/render-level.js"
import * as amdModule123 from "./components/rich-text-with-components.js"
import * as amdModule124 from "./components/slide-prodotti.js"
import * as amdModule125 from "./components/vetrina-prodotti.js"
import * as amdModule126 from "./components/wrap-translation.js"
import * as amdModule127 from "./components/ember-popover.js"
import * as amdModule128 from "./components/ember-tooltip.js"
import * as amdModule129 from "./components/ember-notify.js"
import * as amdModule130 from "./components/ember-notify/message.js"
import * as amdModule131 from "./components/power-calendar-multiple.js"
import * as amdModule132 from "./components/power-calendar-multiple/days.js"
import * as amdModule133 from "./components/power-calendar-range.js"
import * as amdModule134 from "./components/power-calendar-range/days.js"
import * as amdModule135 from "./components/power-calendar.js"
import * as amdModule136 from "./components/power-calendar/days.js"
import * as amdModule137 from "./components/power-calendar/nav.js"
import * as amdModule138 from "./components/payment-method.js"
import * as amdModule139 from "./components/payment-method/payment-section.js"
import * as amdModule140 from "./components/bb-checkbox.js"
import * as amdModule141 from "./components/bb-chip-group.js"
import * as amdModule142 from "./components/bb-color-picker.js"
import * as amdModule143 from "./components/bb-date-range.js"
import * as amdModule144 from "./components/bb-editor.js"
import * as amdModule145 from "./components/bb-focus-input.js"
import * as amdModule146 from "./components/bb-input-currency.js"
import * as amdModule147 from "./components/bb-input-date.js"
import * as amdModule148 from "./components/bb-input-number.js"
import * as amdModule149 from "./components/bb-input-suggestion.js"
import * as amdModule150 from "./components/bb-input-tel.js"
import * as amdModule151 from "./components/bb-radio.js"
import * as amdModule152 from "./components/bb-range-slider.js"
import * as amdModule153 from "./components/bb-select.js"
import * as amdModule154 from "./components/bb-slider.js"
import * as amdModule155 from "./components/bb-textarea.js"
import * as amdModule156 from "./components/bb-toggle.js"
import * as amdModule157 from "./components/quill-editor.js"
import * as amdModule158 from "./components/quill.js"
import * as amdModule159 from "./components/quill/toolbar.js"
import * as amdModule160 from "./components/quill/toolbar/button-or-select.js"
import * as amdModule161 from "./components/quill/toolbar/button.js"
import * as amdModule162 from "./components/quill/toolbar/group.js"
import * as amdModule163 from "./components/quill/toolbar/select.js"
import * as amdModule164 from "./components/bb-custom-field-preview.js"
import * as amdModule165 from "./components/cf-advanced-textarea.js"
import * as amdModule166 from "./components/cf-table.js"
import * as amdModule167 from "./components/custom-field-value.js"
import * as amdModule168 from "./components/edit-custom-field.js"
import * as amdModule169 from "./components/view-custom-field.js"
import * as amdModule170 from "./components/bb-clock.js"
import * as amdModule171 from "./components/bb-time-ago.js"
import * as amdModule172 from "./components/belongs-to.js"
import * as amdModule173 from "./components/has-many.js"
import * as amdModule174 from "./components/related-contacts.js"
import * as amdModule175 from "./components/related-invoices.js"
import * as amdModule176 from "./components/select-association.js"
import * as amdModule177 from "./components/select-association/filter-bar.js"
import * as amdModule178 from "./components/select-association/result-list.js"
import * as amdModule179 from "./components/show-association.js"
import * as amdModule180 from "./components/addresses-list.js"
import * as amdModule181 from "./components/edit-single-address.js"
import * as amdModule182 from "./components/here-map.js"
import * as amdModule183 from "./components/related-addresses.js"
import * as amdModule184 from "./components/base-beebee-component.js"
import * as amdModule185 from "./components/base-edit-component.js"
import * as amdModule186 from "./components/bb-associate-button.js"
import * as amdModule187 from "./components/bb-birth-place-picker.js"
import * as amdModule188 from "./components/bb-chart.js"
import * as amdModule189 from "./components/bb-delete-button.js"
import * as amdModule190 from "./components/bb-dev-toolbar.js"
import * as amdModule191 from "./components/bb-draggable.js"
import * as amdModule192 from "./components/bb-dropdown.js"
import * as amdModule193 from "./components/bb-dropzone.js"
import * as amdModule194 from "./components/bb-email-history.js"
import * as amdModule195 from "./components/bb-expire-date.js"
import * as amdModule196 from "./components/bb-footer-mobile.js"
import * as amdModule197 from "./components/bb-has-many-paginator.js"
import * as amdModule198 from "./components/bb-help-widget.js"
import * as amdModule199 from "./components/bb-list-checkbox.js"
import * as amdModule200 from "./components/bb-list-filter.js"
import * as amdModule201 from "./components/bb-log-modal.js"
import * as amdModule202 from "./components/bb-mascot-loader.js"
import * as amdModule203 from "./components/bb-modal-modern.js"
import * as amdModule204 from "./components/bb-modal.js"
import * as amdModule205 from "./components/bb-paginator.js"
import * as amdModule206 from "./components/bb-panel.js"
import * as amdModule207 from "./components/bb-payment-form-modal.js"
import * as amdModule208 from "./components/bb-payments-list.js"
import * as amdModule209 from "./components/bb-pdf-viewer.js"
import * as amdModule210 from "./components/bb-presence-indicator.js"
import * as amdModule211 from "./components/bb-presence-list.js"
import * as amdModule212 from "./components/bb-reminder-board.js"
import * as amdModule213 from "./components/bb-save-menu.js"
import * as amdModule214 from "./components/bb-spinner.js"
import * as amdModule215 from "./components/bb-status-picker.js"
import * as amdModule216 from "./components/bb-tenant-palette.js"
import * as amdModule217 from "./components/bb-thumbnail.js"
import * as amdModule218 from "./components/bb-user-browser.js"
import * as amdModule219 from "./components/bb-user-platform.js"
import * as amdModule220 from "./components/power-select.js"
import * as amdModule221 from "./components/power-select/before-options.js"
import * as amdModule222 from "./components/power-select/input.js"
import * as amdModule223 from "./components/power-select/label.js"
import * as amdModule224 from "./components/power-select/no-matches-message.js"
import * as amdModule225 from "./components/power-select/options.js"
import * as amdModule226 from "./components/power-select/placeholder.js"
import * as amdModule227 from "./components/power-select/power-select-group.js"
import * as amdModule228 from "./components/power-select/search-message.js"
import * as amdModule229 from "./components/power-select/trigger.js"
import * as amdModule230 from "./components/basic-dropdown-content.js"
import * as amdModule231 from "./components/basic-dropdown-trigger.js"
import * as amdModule232 from "./components/basic-dropdown-wormhole.js"
import * as amdModule233 from "./components/basic-dropdown.js"
import * as amdModule234 from "./components/fa-icon.js"
import * as amdModule235 from "./helpers/format-date.js"
import * as amdModule236 from "./helpers/format-hour.js"
import * as amdModule237 from "./helpers/format-number.js"
import * as amdModule238 from "./helpers/t.js"
import * as amdModule239 from "./helpers/thumb-letter.js"
import * as amdModule240 from "./helpers/ensure-safe-component.js"
import * as amdModule241 from "./helpers/app-version.js"
import * as amdModule242 from "./helpers/pluralize.js"
import * as amdModule243 from "./helpers/singularize.js"
import * as amdModule244 from "./helpers/ember-power-calendar-day-classes.js"
import * as amdModule245 from "./helpers/power-calendar-format-date.js"
import * as amdModule246 from "./helpers/and.js"
import * as amdModule247 from "./helpers/eq.js"
import * as amdModule248 from "./helpers/gt.js"
import * as amdModule249 from "./helpers/gte.js"
import * as amdModule250 from "./helpers/is-array.js"
import * as amdModule251 from "./helpers/is-empty.js"
import * as amdModule252 from "./helpers/is-equal.js"
import * as amdModule253 from "./helpers/lt.js"
import * as amdModule254 from "./helpers/lte.js"
import * as amdModule255 from "./helpers/not-eq.js"
import * as amdModule256 from "./helpers/not.js"
import * as amdModule257 from "./helpers/or.js"
import * as amdModule258 from "./helpers/xor.js"
import * as amdModule259 from "./helpers/assign.js"
import * as amdModule260 from "./helpers/if-key.js"
import * as amdModule261 from "./helpers/on-key.js"
import * as amdModule262 from "./helpers/brightness-by-color.js"
import * as amdModule263 from "./helpers/collection-contain.js"
import * as amdModule264 from "./helpers/collection-list.js"
import * as amdModule265 from "./helpers/component-exists.js"
import * as amdModule266 from "./helpers/concat-string.js"
import * as amdModule267 from "./helpers/css-style.js"
import * as amdModule268 from "./helpers/custom-field-icon.js"
import * as amdModule269 from "./helpers/date-diff-year.js"
import * as amdModule270 from "./helpers/date-diff.js"
import * as amdModule271 from "./helpers/date-ticks.js"
import * as amdModule272 from "./helpers/day-name.js"
import * as amdModule273 from "./helpers/def-currency.js"
import * as amdModule274 from "./helpers/first-object.js"
import * as amdModule275 from "./helpers/format-euro.js"
import * as amdModule276 from "./helpers/format-minute2string-day.js"
import * as amdModule277 from "./helpers/format-minute2string.js"
import * as amdModule278 from "./helpers/format-number2string.js"
import * as amdModule279 from "./helpers/generate-id.js"
import * as amdModule280 from "./helpers/human-custom-field-name.js"
import * as amdModule281 from "./helpers/icon-here.js"
import * as amdModule282 from "./helpers/in-array.js"
import * as amdModule283 from "./helpers/is-equal-large.js"
import * as amdModule284 from "./helpers/is-equal-not-empty.js"
import * as amdModule285 from "./helpers/is-gt.js"
import * as amdModule286 from "./helpers/is-image.js"
import * as amdModule287 from "./helpers/is-not.js"
import * as amdModule288 from "./helpers/is-pdf.js"
import * as amdModule289 from "./helpers/number-diff.js"
import * as amdModule290 from "./helpers/number-div.js"
import * as amdModule291 from "./helpers/number-mult.js"
import * as amdModule292 from "./helpers/number-sum.js"
import * as amdModule293 from "./helpers/number-to-hour.js"
import * as amdModule294 from "./helpers/read-path.js"
import * as amdModule295 from "./helpers/replace-br2comas.js"
import * as amdModule296 from "./helpers/safe-string.js"
import * as amdModule297 from "./helpers/set.js"
import * as amdModule298 from "./helpers/time-tickstotext.js"
import * as amdModule299 from "./helpers/todo-date-diff.js"
import * as amdModule300 from "./helpers/ember-power-select-is-array.js"
import * as amdModule301 from "./helpers/ember-power-select-is-equal.js"
import * as amdModule302 from "./helpers/ember-power-select-is-group.js"
import * as amdModule303 from "./helpers/ember-power-select-is-selected-present.js"
import * as amdModule304 from "./helpers/format-date-range.js"
import * as amdModule305 from "./helpers/format-display-name.js"
import * as amdModule306 from "./helpers/format-list.js"
import * as amdModule307 from "./helpers/format-message.js"
import * as amdModule308 from "./helpers/format-relative-time.js"
import * as amdModule309 from "./helpers/format-time.js"
import * as amdModule310 from "./helpers/t-key.js"
import * as amdModule311 from "./helpers/cancel-all.js"
import * as amdModule312 from "./helpers/perform.js"
import * as amdModule313 from "./helpers/task.js"
import * as amdModule314 from "./helpers/element.js"
import * as amdModule315 from "./modifiers/on-key.js"
import * as amdModule316 from "./modifiers/autofocus.js"
import * as amdModule317 from "./modifiers/dhtmlx-tooltip-guard.js"
import * as amdModule318 from "./modifiers/scroll-top-on-insert.js"
import * as amdModule319 from "./modifiers/basic-dropdown-trigger.js"
import * as amdModule320 from "./modifiers/style.js"
import * as amdModule321 from "./modifiers/did-insert.js"
import * as amdModule322 from "./modifiers/did-update.js"
import * as amdModule323 from "./modifiers/will-destroy.js"
import * as amdModule324 from "./templates/application.hbs"
import * as amdModule325 from "./controllers/application.js"
import * as amdModule326 from "./routes/application.js"
import * as amdModule327 from "./templates/checkin.hbs"
import * as amdModule328 from "./controllers/checkin.js"
import * as amdModule329 from "./routes/checkin.js"
import * as amdModule330 from "./templates/checkout.hbs"
import * as amdModule331 from "./controllers/checkout.js"
import * as amdModule332 from "./routes/checkout.js"
import * as amdModule333 from "./templates/confirm.hbs"
import * as amdModule334 from "./controllers/confirm.js"
import * as amdModule335 from "./routes/confirm.js"
import * as amdModule336 from "./templates/detail.hbs"
import * as amdModule337 from "./controllers/detail.js"
import * as amdModule338 from "./routes/detail.js"
import * as amdModule339 from "./templates/gift.hbs"
import * as amdModule340 from "./controllers/gift.js"
import * as amdModule341 from "./routes/gift.js"
import * as amdModule342 from "./templates/index.hbs"
import * as amdModule343 from "./controllers/index.js"
import * as amdModule344 from "./routes/index.js"
import * as amdModule345 from "./templates/list.hbs"
import * as amdModule346 from "./controllers/list.js"
import * as amdModule347 from "./routes/list.js"
import * as amdModule348 from "./templates/payment-request.hbs"
import * as amdModule349 from "./controllers/payment-request.js"
import * as amdModule350 from "./routes/payment-request.js"
import * as amdModule351 from "./templates/payment-status.hbs"
import * as amdModule352 from "./controllers/payment-status.js"
import * as amdModule353 from "./routes/payment-status.js"
import * as amdModule354 from "./templates/ski-instructor.hbs"
import * as amdModule355 from "./controllers/ski-instructor.js"
import * as amdModule356 from "./routes/ski-instructor.js"
import * as amdModule357 from "./templates/user.hbs"
import * as amdModule358 from "./controllers/user.js"
import * as amdModule359 from "./routes/user.js"
import * as amdModule360 from "./routes/private.js"
import * as amdModule361 from "./templates/404.hbs"
import * as amdModule362 from "./templates/error.hbs"
import * as amdModule363 from "./templates/loading.hbs"
import * as amdModule364 from "./routes/token-login.js"

let exportFastbootModules = {};





export default Object.assign(
  {},
defineModule0,
  {
"e-commerce/initializers/ember-data-identifiers": amdModule0,
"e-commerce/lib/default-comprensorio": amdModule1,
"e-commerce/resolver": amdModule2,
"e-commerce/router": amdModule3,
"e-commerce/serializers/application": amdModule4,
"e-commerce/services/intl": amdModule5,
"e-commerce/services/keyboard": amdModule6,
"e-commerce/services/theme": amdModule7,
"e-commerce/services/-ensure-registered": amdModule8,
"e-commerce/services/notify": amdModule9,
"e-commerce/initializers/app-version": amdModule10,
"e-commerce/instance-initializers/sentry-performance": amdModule11,
"e-commerce/instance-initializers/load-translations": amdModule12,
"e-commerce/services/power-calendar": amdModule13,
"e-commerce/test-support/helpers": amdModule14,
"e-commerce/initializers/ember-data": amdModule15,
"e-commerce/services/store": amdModule16,
"e-commerce/transforms/date": amdModule17,
"e-commerce/transforms/number": amdModule18,
"e-commerce/transforms/string": amdModule19,
"e-commerce/transforms/boolean": amdModule20,
"e-commerce/data-adapter": amdModule21,
"e-commerce/services/quill": amdModule22,
"e-commerce/adapters/application": amdModule23,
"e-commerce/adapters/contact": amdModule24,
"e-commerce/adapters/organization": amdModule25,
"e-commerce/models/address": amdModule26,
"e-commerce/models/application": amdModule27,
"e-commerce/models/assurance": amdModule28,
"e-commerce/models/category": amdModule29,
"e-commerce/models/contact-consensi": amdModule30,
"e-commerce/models/contact-parent": amdModule31,
"e-commerce/models/contact-state": amdModule32,
"e-commerce/models/contact": amdModule33,
"e-commerce/models/custom-field-definition": amdModule34,
"e-commerce/models/custom-field": amdModule35,
"e-commerce/models/custom-reminder": amdModule36,
"e-commerce/models/event-state": amdModule37,
"e-commerce/models/event": amdModule38,
"e-commerce/models/expense": amdModule39,
"e-commerce/models/expensearticle": amdModule40,
"e-commerce/models/expensepayment": amdModule41,
"e-commerce/models/expire-date": amdModule42,
"e-commerce/models/file": amdModule43,
"e-commerce/models/invoice-style": amdModule44,
"e-commerce/models/invoice": amdModule45,
"e-commerce/models/invoicegroup": amdModule46,
"e-commerce/models/invoicemailsend": amdModule47,
"e-commerce/models/invoiceproduct-tax": amdModule48,
"e-commerce/models/invoiceproduct": amdModule49,
"e-commerce/models/invoices-notifiche-sdi": amdModule50,
"e-commerce/models/invoicetax": amdModule51,
"e-commerce/models/log": amdModule52,
"e-commerce/models/notification": amdModule53,
"e-commerce/models/organization-custom-field": amdModule54,
"e-commerce/models/organization": amdModule55,
"e-commerce/models/payment-method": amdModule56,
"e-commerce/models/payment": amdModule57,
"e-commerce/models/plan": amdModule58,
"e-commerce/models/product-category": amdModule59,
"e-commerce/models/product-state": amdModule60,
"e-commerce/models/product": amdModule61,
"e-commerce/models/project-consensi": amdModule62,
"e-commerce/models/project-state": amdModule63,
"e-commerce/models/project": amdModule64,
"e-commerce/models/reminder-setting": amdModule65,
"e-commerce/models/reminder": amdModule66,
"e-commerce/models/role": amdModule67,
"e-commerce/models/sub-category": amdModule68,
"e-commerce/models/subscription": amdModule69,
"e-commerce/models/tag": amdModule70,
"e-commerce/models/todo": amdModule71,
"e-commerce/models/todolist": amdModule72,
"e-commerce/models/user-calendar": amdModule73,
"e-commerce/models/user-invoice-setting": amdModule74,
"e-commerce/models/user-reminder": amdModule75,
"e-commerce/models/user-sezionale": amdModule76,
"e-commerce/models/user-tax": amdModule77,
"e-commerce/models/workhour-state": amdModule78,
"e-commerce/models/workhour": amdModule79,
"e-commerce/services/session": amdModule80,
"e-commerce/core-app": amdModule81,
"e-commerce/formats": amdModule82,
"e-commerce/initializers/fontawesome": amdModule83,
"e-commerce/initializers/offline-banner": amdModule84,
"e-commerce/instance-initializers/dev-host": amdModule85,
"e-commerce/services/app-state": amdModule86,
"e-commerce/services/application": amdModule87,
"e-commerce/services/beebee-base": amdModule88,
"e-commerce/services/document-sign": amdModule89,
"e-commerce/services/idle-screensaver": amdModule90,
"e-commerce/services/index-context": amdModule91,
"e-commerce/services/log": amdModule92,
"e-commerce/services/modal-stack": amdModule93,
"e-commerce/services/modal": amdModule94,
"e-commerce/services/new-record-factory": amdModule95,
"e-commerce/services/notification-message": amdModule96,
"e-commerce/services/ringtone": amdModule97,
"e-commerce/services/role-checker": amdModule98,
"e-commerce/services/socket-sync": amdModule99,
"e-commerce/services/socket-tracker": amdModule100,
"e-commerce/services/third-party-boot": amdModule101,
"e-commerce/services/window-viewport": amdModule102,
"e-commerce/components/assicurazione-aosta-valley": amdModule103,
"e-commerce/components/assicurazione-snow-care": amdModule104,
"e-commerce/components/base-product-price": amdModule105,
"e-commerce/components/bb-field": amdModule106,
"e-commerce/components/checkout-detail": amdModule107,
"e-commerce/components/checkout-product": amdModule108,
"e-commerce/components/cookie-banner": amdModule109,
"e-commerce/components/custom-modules": amdModule110,
"e-commerce/components/detail-calendar": amdModule111,
"e-commerce/components/empty-category": amdModule112,
"e-commerce/components/human-age": amdModule113,
"e-commerce/components/inline-login": amdModule114,
"e-commerce/components/level-selector": amdModule115,
"e-commerce/components/list-cart-product": amdModule116,
"e-commerce/components/list-filters": amdModule117,
"e-commerce/components/list-levels": amdModule118,
"e-commerce/components/not-available-label": amdModule119,
"e-commerce/components/private-calendar": amdModule120,
"e-commerce/components/product-list": amdModule121,
"e-commerce/components/render-level": amdModule122,
"e-commerce/components/rich-text-with-components": amdModule123,
"e-commerce/components/slide-prodotti": amdModule124,
"e-commerce/components/vetrina-prodotti": amdModule125,
"e-commerce/components/wrap-translation": amdModule126,
"e-commerce/components/ember-popover": amdModule127,
"e-commerce/components/ember-tooltip": amdModule128,
"e-commerce/components/ember-notify": amdModule129,
"e-commerce/components/ember-notify/message": amdModule130,
"e-commerce/components/power-calendar-multiple": amdModule131,
"e-commerce/components/power-calendar-multiple/days": amdModule132,
"e-commerce/components/power-calendar-range": amdModule133,
"e-commerce/components/power-calendar-range/days": amdModule134,
"e-commerce/components/power-calendar": amdModule135,
"e-commerce/components/power-calendar/days": amdModule136,
"e-commerce/components/power-calendar/nav": amdModule137,
"e-commerce/components/payment-method": amdModule138,
"e-commerce/components/payment-method/payment-section": amdModule139,
"e-commerce/components/bb-checkbox": amdModule140,
"e-commerce/components/bb-chip-group": amdModule141,
"e-commerce/components/bb-color-picker": amdModule142,
"e-commerce/components/bb-date-range": amdModule143,
"e-commerce/components/bb-editor": amdModule144,
"e-commerce/components/bb-focus-input": amdModule145,
"e-commerce/components/bb-input-currency": amdModule146,
"e-commerce/components/bb-input-date": amdModule147,
"e-commerce/components/bb-input-number": amdModule148,
"e-commerce/components/bb-input-suggestion": amdModule149,
"e-commerce/components/bb-input-tel": amdModule150,
"e-commerce/components/bb-radio": amdModule151,
"e-commerce/components/bb-range-slider": amdModule152,
"e-commerce/components/bb-select": amdModule153,
"e-commerce/components/bb-slider": amdModule154,
"e-commerce/components/bb-textarea": amdModule155,
"e-commerce/components/bb-toggle": amdModule156,
"e-commerce/components/quill-editor": amdModule157,
"e-commerce/components/quill": amdModule158,
"e-commerce/components/quill/toolbar": amdModule159,
"e-commerce/components/quill/toolbar/button-or-select": amdModule160,
"e-commerce/components/quill/toolbar/button": amdModule161,
"e-commerce/components/quill/toolbar/group": amdModule162,
"e-commerce/components/quill/toolbar/select": amdModule163,
"e-commerce/components/bb-custom-field-preview": amdModule164,
"e-commerce/components/cf-advanced-textarea": amdModule165,
"e-commerce/components/cf-table": amdModule166,
"e-commerce/components/custom-field-value": amdModule167,
"e-commerce/components/edit-custom-field": amdModule168,
"e-commerce/components/view-custom-field": amdModule169,
"e-commerce/components/bb-clock": amdModule170,
"e-commerce/components/bb-time-ago": amdModule171,
"e-commerce/components/belongs-to": amdModule172,
"e-commerce/components/has-many": amdModule173,
"e-commerce/components/related-contacts": amdModule174,
"e-commerce/components/related-invoices": amdModule175,
"e-commerce/components/select-association": amdModule176,
"e-commerce/components/select-association/filter-bar": amdModule177,
"e-commerce/components/select-association/result-list": amdModule178,
"e-commerce/components/show-association": amdModule179,
"e-commerce/components/addresses-list": amdModule180,
"e-commerce/components/edit-single-address": amdModule181,
"e-commerce/components/here-map": amdModule182,
"e-commerce/components/related-addresses": amdModule183,
"e-commerce/components/base-beebee-component": amdModule184,
"e-commerce/components/base-edit-component": amdModule185,
"e-commerce/components/bb-associate-button": amdModule186,
"e-commerce/components/bb-birth-place-picker": amdModule187,
"e-commerce/components/bb-chart": amdModule188,
"e-commerce/components/bb-delete-button": amdModule189,
"e-commerce/components/bb-dev-toolbar": amdModule190,
"e-commerce/components/bb-draggable": amdModule191,
"e-commerce/components/bb-dropdown": amdModule192,
"e-commerce/components/bb-dropzone": amdModule193,
"e-commerce/components/bb-email-history": amdModule194,
"e-commerce/components/bb-expire-date": amdModule195,
"e-commerce/components/bb-footer-mobile": amdModule196,
"e-commerce/components/bb-has-many-paginator": amdModule197,
"e-commerce/components/bb-help-widget": amdModule198,
"e-commerce/components/bb-list-checkbox": amdModule199,
"e-commerce/components/bb-list-filter": amdModule200,
"e-commerce/components/bb-log-modal": amdModule201,
"e-commerce/components/bb-mascot-loader": amdModule202,
"e-commerce/components/bb-modal-modern": amdModule203,
"e-commerce/components/bb-modal": amdModule204,
"e-commerce/components/bb-paginator": amdModule205,
"e-commerce/components/bb-panel": amdModule206,
"e-commerce/components/bb-payment-form-modal": amdModule207,
"e-commerce/components/bb-payments-list": amdModule208,
"e-commerce/components/bb-pdf-viewer": amdModule209,
"e-commerce/components/bb-presence-indicator": amdModule210,
"e-commerce/components/bb-presence-list": amdModule211,
"e-commerce/components/bb-reminder-board": amdModule212,
"e-commerce/components/bb-save-menu": amdModule213,
"e-commerce/components/bb-spinner": amdModule214,
"e-commerce/components/bb-status-picker": amdModule215,
"e-commerce/components/bb-tenant-palette": amdModule216,
"e-commerce/components/bb-thumbnail": amdModule217,
"e-commerce/components/bb-user-browser": amdModule218,
"e-commerce/components/bb-user-platform": amdModule219,
"e-commerce/components/power-select": amdModule220,
"e-commerce/components/power-select/before-options": amdModule221,
"e-commerce/components/power-select/input": amdModule222,
"e-commerce/components/power-select/label": amdModule223,
"e-commerce/components/power-select/no-matches-message": amdModule224,
"e-commerce/components/power-select/options": amdModule225,
"e-commerce/components/power-select/placeholder": amdModule226,
"e-commerce/components/power-select/power-select-group": amdModule227,
"e-commerce/components/power-select/search-message": amdModule228,
"e-commerce/components/power-select/trigger": amdModule229,
"e-commerce/components/basic-dropdown-content": amdModule230,
"e-commerce/components/basic-dropdown-trigger": amdModule231,
"e-commerce/components/basic-dropdown-wormhole": amdModule232,
"e-commerce/components/basic-dropdown": amdModule233,
"e-commerce/components/fa-icon": amdModule234,
"e-commerce/helpers/format-date": amdModule235,
"e-commerce/helpers/format-hour": amdModule236,
"e-commerce/helpers/format-number": amdModule237,
"e-commerce/helpers/t": amdModule238,
"e-commerce/helpers/thumb-letter": amdModule239,
"e-commerce/helpers/ensure-safe-component": amdModule240,
"e-commerce/helpers/app-version": amdModule241,
"e-commerce/helpers/pluralize": amdModule242,
"e-commerce/helpers/singularize": amdModule243,
"e-commerce/helpers/ember-power-calendar-day-classes": amdModule244,
"e-commerce/helpers/power-calendar-format-date": amdModule245,
"e-commerce/helpers/and": amdModule246,
"e-commerce/helpers/eq": amdModule247,
"e-commerce/helpers/gt": amdModule248,
"e-commerce/helpers/gte": amdModule249,
"e-commerce/helpers/is-array": amdModule250,
"e-commerce/helpers/is-empty": amdModule251,
"e-commerce/helpers/is-equal": amdModule252,
"e-commerce/helpers/lt": amdModule253,
"e-commerce/helpers/lte": amdModule254,
"e-commerce/helpers/not-eq": amdModule255,
"e-commerce/helpers/not": amdModule256,
"e-commerce/helpers/or": amdModule257,
"e-commerce/helpers/xor": amdModule258,
"e-commerce/helpers/assign": amdModule259,
"e-commerce/helpers/if-key": amdModule260,
"e-commerce/helpers/on-key": amdModule261,
"e-commerce/helpers/brightness-by-color": amdModule262,
"e-commerce/helpers/collection-contain": amdModule263,
"e-commerce/helpers/collection-list": amdModule264,
"e-commerce/helpers/component-exists": amdModule265,
"e-commerce/helpers/concat-string": amdModule266,
"e-commerce/helpers/css-style": amdModule267,
"e-commerce/helpers/custom-field-icon": amdModule268,
"e-commerce/helpers/date-diff-year": amdModule269,
"e-commerce/helpers/date-diff": amdModule270,
"e-commerce/helpers/date-ticks": amdModule271,
"e-commerce/helpers/day-name": amdModule272,
"e-commerce/helpers/def-currency": amdModule273,
"e-commerce/helpers/first-object": amdModule274,
"e-commerce/helpers/format-euro": amdModule275,
"e-commerce/helpers/format-minute2string-day": amdModule276,
"e-commerce/helpers/format-minute2string": amdModule277,
"e-commerce/helpers/format-number2string": amdModule278,
"e-commerce/helpers/generate-id": amdModule279,
"e-commerce/helpers/human-custom-field-name": amdModule280,
"e-commerce/helpers/icon-here": amdModule281,
"e-commerce/helpers/in-array": amdModule282,
"e-commerce/helpers/is-equal-large": amdModule283,
"e-commerce/helpers/is-equal-not-empty": amdModule284,
"e-commerce/helpers/is-gt": amdModule285,
"e-commerce/helpers/is-image": amdModule286,
"e-commerce/helpers/is-not": amdModule287,
"e-commerce/helpers/is-pdf": amdModule288,
"e-commerce/helpers/number-diff": amdModule289,
"e-commerce/helpers/number-div": amdModule290,
"e-commerce/helpers/number-mult": amdModule291,
"e-commerce/helpers/number-sum": amdModule292,
"e-commerce/helpers/number-to-hour": amdModule293,
"e-commerce/helpers/read-path": amdModule294,
"e-commerce/helpers/replace-br2comas": amdModule295,
"e-commerce/helpers/safe-string": amdModule296,
"e-commerce/helpers/set": amdModule297,
"e-commerce/helpers/time-tickstotext": amdModule298,
"e-commerce/helpers/todo-date-diff": amdModule299,
"e-commerce/helpers/ember-power-select-is-array": amdModule300,
"e-commerce/helpers/ember-power-select-is-equal": amdModule301,
"e-commerce/helpers/ember-power-select-is-group": amdModule302,
"e-commerce/helpers/ember-power-select-is-selected-present": amdModule303,
"e-commerce/helpers/format-date-range": amdModule304,
"e-commerce/helpers/format-display-name": amdModule305,
"e-commerce/helpers/format-list": amdModule306,
"e-commerce/helpers/format-message": amdModule307,
"e-commerce/helpers/format-relative-time": amdModule308,
"e-commerce/helpers/format-time": amdModule309,
"e-commerce/helpers/t-key": amdModule310,
"e-commerce/helpers/cancel-all": amdModule311,
"e-commerce/helpers/perform": amdModule312,
"e-commerce/helpers/task": amdModule313,
"e-commerce/helpers/element": amdModule314,
"e-commerce/modifiers/on-key": amdModule315,
"e-commerce/modifiers/autofocus": amdModule316,
"e-commerce/modifiers/dhtmlx-tooltip-guard": amdModule317,
"e-commerce/modifiers/scroll-top-on-insert": amdModule318,
"e-commerce/modifiers/basic-dropdown-trigger": amdModule319,
"e-commerce/modifiers/style": amdModule320,
"e-commerce/modifiers/did-insert": amdModule321,
"e-commerce/modifiers/did-update": amdModule322,
"e-commerce/modifiers/will-destroy": amdModule323,
"e-commerce/templates/application": amdModule324,
"e-commerce/controllers/application": amdModule325,
"e-commerce/routes/application": amdModule326,
"e-commerce/templates/checkin": amdModule327,
"e-commerce/controllers/checkin": amdModule328,
"e-commerce/routes/checkin": amdModule329,
"e-commerce/templates/checkout": amdModule330,
"e-commerce/controllers/checkout": amdModule331,
"e-commerce/routes/checkout": amdModule332,
"e-commerce/templates/confirm": amdModule333,
"e-commerce/controllers/confirm": amdModule334,
"e-commerce/routes/confirm": amdModule335,
"e-commerce/templates/detail": amdModule336,
"e-commerce/controllers/detail": amdModule337,
"e-commerce/routes/detail": amdModule338,
"e-commerce/templates/gift": amdModule339,
"e-commerce/controllers/gift": amdModule340,
"e-commerce/routes/gift": amdModule341,
"e-commerce/templates/index": amdModule342,
"e-commerce/controllers/index": amdModule343,
"e-commerce/routes/index": amdModule344,
"e-commerce/templates/list": amdModule345,
"e-commerce/controllers/list": amdModule346,
"e-commerce/routes/list": amdModule347,
"e-commerce/templates/payment-request": amdModule348,
"e-commerce/controllers/payment-request": amdModule349,
"e-commerce/routes/payment-request": amdModule350,
"e-commerce/templates/payment-status": amdModule351,
"e-commerce/controllers/payment-status": amdModule352,
"e-commerce/routes/payment-status": amdModule353,
"e-commerce/templates/ski-instructor": amdModule354,
"e-commerce/controllers/ski-instructor": amdModule355,
"e-commerce/routes/ski-instructor": amdModule356,
"e-commerce/templates/user": amdModule357,
"e-commerce/controllers/user": amdModule358,
"e-commerce/routes/user": amdModule359,
"e-commerce/routes/private": amdModule360,
"e-commerce/templates/404": amdModule361,
"e-commerce/templates/error": amdModule362,
"e-commerce/templates/loading": amdModule363,
"e-commerce/routes/token-login": amdModule364,
  },
  exportFastbootModules
);
